import { Col, Row, TextInput } from '@digitools/honest-react';
import React from 'react';
import useBdmLciConfig from '../../../../../hooks/useBdmLciConfig';
import useExperience from '../../../../../hooks/useExperience';
import { getLabels } from '../../../utils/LCIUtils';
import { formatCurrency, decimalDollar, validateCurrencyOptional } from '../../../../../utils/validationUtils';
import { useFormApi } from 'informed';
import { LciValidationLabels } from '../../../constants/LciValidationLabels';
const CoverageAmount = ({ claimant, event }) => {
    const { customContents } = useBdmLciConfig();
    const { language } = useExperience();
    const getCustomLabels = getLabels(customContents, language);
    const labelEmployee = getCustomLabels.employee || 'Employee';
    const formApi = useFormApi();
    const handleBlur = (field) => (e) => {
        const val = formApi.getValue(field);
        formApi.setValue(field, decimalDollar(val));
    };
    return (<>
      <Row>
        <Col lg={4} md={6} sm={12}>
          <TextInput ariaLabelText={'Employee basic amount'} field={'policyInfo_basicAmount'} icon={'usd'} label={`${labelEmployee} basic (optional)`} data-private={true} mask={formatCurrency} onBlur={handleBlur('policyInfo_basicAmount')} type={'text'} validate={(value) => validateCurrencyOptional(value, LciValidationLabels.employeeBasic)} validateOnChange={true}/>
        </Col>
        <Col lg={4} md={6} sm={12}>
          <TextInput ariaLabelText={'Employee basic AD&D amount'} field={'policyInfo_basicADandDAmount'} icon={'usd'} label={`${labelEmployee} basic AD&D (optional)`} data-private={true} mask={formatCurrency} onBlur={handleBlur('policyInfo_basicADandDAmount')} type={'text'} validate={(value) => validateCurrencyOptional(value, LciValidationLabels.employeeBasicADD)} validateOnChange={true}/>
        </Col>
        <Col lg={4} md={6} sm={12}>
          <TextInput ariaLabelText={'Employee optional amount'} field={'policyInfo_optionalAmount'} icon={'usd'} label={`${labelEmployee} optional (optional)`} data-private={true} mask={formatCurrency} onBlur={handleBlur('policyInfo_optionalAmount')} type={'text'} validate={(value) => validateCurrencyOptional(value, LciValidationLabels.employeeOptional)} validateOnChange={true}/>
        </Col>
      </Row>
      <Row style={{ marginTop: 0 }}>
        <Col lg={4} md={6} sm={12}>
          <TextInput ariaLabelText={'Employee optional AD&D amount'} field={'policyInfo_optionalADandDAmount'} icon={'usd'} label={`${labelEmployee} optional AD&D (optional)`} data-private={true} mask={formatCurrency} onBlur={handleBlur('policyInfo_optionalADandDAmount')} type={'text'} validate={(value) => validateCurrencyOptional(value, LciValidationLabels.employeeOptionalADD)} validateOnChange={true}/>
        </Col>
      </Row>
    </>);
};
export default CoverageAmount;
